import React, { Component } from 'react';
import {Dummy} from '../'

export default class EnergoAll extends Dummy {
	
  paintCanvas(cvs) {
  var canvas = document.getElementById(cvs);
  if (canvas.getContext) {
    var ctx = canvas.getContext('2d');

      ctx.fillStyle = "#41adad";
    	 ctx.fillRect(0,0,1100,750);

 ctx.lineWidth= 1;

      ctx.setLineDash([6]);
      ctx.strokeRect(25,95,756,500);


    ctx.fillStyle = "red";
    ctx.beginPath();
    ctx.moveTo(511,5);
    ctx.lineTo(527,21);
    ctx.lineTo(527,82);
    ctx.lineTo(495,82);
    ctx.lineTo(495,21);
    ctx.lineTo(511,5);
    ctx.fill();
    ctx.closePath(); 
    
    ctx.fillStyle = "black";
    ctx.beginPath();
    ctx.moveTo(492,45);
    ctx.lineTo(484,50);
    ctx.lineTo(484,40);
    ctx.lineTo(492,45);
    ctx.fill();
    ctx.closePath(); 
    
    ctx.fillStyle = "black";
    ctx.beginPath();
    ctx.moveTo(530,45);
    ctx.lineTo(538,50);
    ctx.lineTo(538,40);
    ctx.lineTo(530,45);
    ctx.fill();
    ctx.closePath();

    ctx.fillStyle = "red";
    ctx.beginPath();
    ctx.moveTo(296,299);
    ctx.lineTo(296,357);
    ctx.lineTo(410,357);
    ctx.lineTo(439,328);
    ctx.lineTo(410,299);
    ctx.lineTo(296,299);
    ctx.fill();
    ctx.closePath(); 

    ctx.fillStyle = "red";
    ctx.beginPath();
    ctx.moveTo(582,299);
    ctx.lineTo(582,357);
    ctx.lineTo(820,357);
    ctx.lineTo(849,328);
    ctx.lineTo(820,299);
    ctx.lineTo(582,299);
    ctx.fill();
    ctx.closePath(); 

     ctx.fillStyle = "black";
    ctx.beginPath();
    ctx.moveTo(365,295);
    ctx.lineTo(360,287);
    ctx.lineTo(370,287);
    ctx.lineTo(365,295);
    ctx.fill();
    ctx.closePath(); 
    
     ctx.fillStyle = "black";
    ctx.beginPath();
    ctx.moveTo(365,361);
    ctx.lineTo(360,369);
    ctx.lineTo(370,369);
    ctx.lineTo(365,361);
    ctx.fill();
    ctx.closePath(); 
    
     ctx.fillStyle = "black";
    ctx.beginPath();
    ctx.moveTo(713,295);
    ctx.lineTo(708,287);
    ctx.lineTo(718,287);
    ctx.lineTo(713,295);
    ctx.fill();
    ctx.closePath(); 
    
     ctx.fillStyle = "black";
    ctx.beginPath();
    ctx.moveTo(713,361);
    ctx.lineTo(708,369);
    ctx.lineTo(718,369);
    ctx.lineTo(713,361);
    ctx.fill();
    ctx.closePath(); 

     ctx.fillStyle = "black";
    ctx.beginPath();
    ctx.moveTo(510,408);
    ctx.lineTo(505,416);
    ctx.lineTo(515,416);
    ctx.lineTo(510,408);
    ctx.fill();
    ctx.closePath();

     ctx.beginPath();
     ctx.fillStyle= "#1E90FF";
     ctx.arc(980,328,110,0,Math.PI*2,true);
     ctx.fill();
     }
};

  
    render() {
        return (
                <canvas className='cvs' id={this.props.canvas_id} width="1100" height="750"></canvas>
        );
    }
}

EnergoAll.propTypes = {
    canvas_id: React.PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/entries/EnergoAll/index.jsx